import { render, staticRenderFns } from "./_form.applications.page.vue?vue&type=template&id=5270854b&scoped=true&"
import script from "./_form.applications.page.vue?vue&type=script&lang=js&"
export * from "./_form.applications.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.applications.page.vue?vue&type=style&index=0&id=5270854b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270854b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
